exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.h6[data-v-4c85896a] {\n    font-size: 14px;\n    font-weight: normal;\n    font-family: \"Sen\", \"sans-serif\";\n    color: #7e7e7e;\n}\n", ""]);

// exports
